'use client'
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/richText.ts
var RICHTEXT_QUERY = `
json
links {
  assets {
    block {${IMAGE_QUERY}}
  }
}`;

export {
  RICHTEXT_QUERY
};
//# sourceMappingURL=chunk-G62SUGCR.mjs.map